import React from 'react';

const CloseIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="16" fill="#08081B" fillOpacity="0.05"/>
      <path d="M12 12L19.9998 19.9998M20 12L12.0002 19.9998M16 16H16.0107" stroke="#525365" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  );
};

export default CloseIcon;